/*** IMPORTS FROM imports-loader ***/
var define = false;

export default class RetinaChanges {

    constructor(mainContainer) {
        this.mainContainer = mainContainer;
    }

    _RetinaChangesJs() {

        if (window.devicePixelRatio <= 1) return false;

        let lowresImages = $(this.mainContainer);

        lowresImages.each(function (i) {
            let lowres = $(this).attr('src');
            let highres = lowres.replace("@1x.", "@2x.");
            $(this).attr('src', highres);
        });
    }

    _isExist() {
        return $(this.mainContainer).length !== 0;
    }

    init() {

        if (!this._isExist()) return false;

        this._RetinaChangesJs();
    }


}




// WEBPACK FOOTER //
// ./app/Sites/AT/assets/js/modules/RetinaChanges.js